import * as React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from "@material-ui/core/TextField";
import { Grid } from '@material-ui/core';
import Text from '../Text/Text';
import InputMask from 'react-input-mask';

const useStyles = makeStyles((theme) => ({
    textField: {
        "& div input": {
          padding: "7px 12px 10px",
        },
        width: "100%",
      },
}));

const TextInputWithMasking=(props)=>{
    const{label,onChange,value,name,placeHolder,mask}=props;
   
const classes=useStyles()
return (
       <>
      <div>
        <Grid container xs={12} justify="space-between">
            <Grid item>   
            <Text>{label||""}</Text>
            </Grid>
       </Grid>
       <InputMask mask={mask} maskChar={null} value={value}  onChange={onChange}>
        {(inputProps) =>  <TextField
            id="filled-basic"
            variant="filled"
            className={classes.textField}
            name={name}
            value={value||""}
            onChange={onChange}
            placeholder={placeHolder||""}
            // {...inputProps}
          />}
         </InputMask>
       
        </div>
       </>
  );
};

export default TextInputWithMasking;